export const DIALOG = {
  title: "Are you sure you want to apply the changes to your profile information?",
  message: "Once confirmed, new information will be updated and visible on user profile.All previous data will be replaced with the new information you provided. Please review your changes carefully before proceeding.",
};
